import type { SVGProps } from "react";
// generated from Calendar.svg — do not edit manually
// prettier-ignore
export default function Calendar(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 3 10 V 18 C 3 20.209 4.791 22 7 22 H 17 C 19.209 22 21 20.209 21 18 V 10 M 3 10 V 8 C 3 5.791 4.791 4 7 4 H 8 M 3 10 H 21 M 21 10 V 8 C 21 5.791 19.209 4 17 4 H 16 M 8 4 V 1 M 8 4 V 7 M 8 4 H 16 M 16 4 V 1 M 16 4 V 7" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
